import html2canvas from 'html2canvas';
import { PDF_CONFIG, CANVAS_CLONE_STYLES } from './pdfConstants';

/**
 * تحويل HTML إلى Canvas
 */
export const renderHtmlToCanvas = async (containerDiv: HTMLDivElement): Promise<HTMLCanvasElement> => {
  console.log('📸 جاري تصوير المحتوى...');
  console.log('📏 أبعاد المحتوى:', {
    width: containerDiv.offsetWidth,
    height: containerDiv.offsetHeight,
    scrollHeight: containerDiv.scrollHeight
  });
  
  try {
    const canvas = await html2canvas(containerDiv, {
      scale: PDF_CONFIG.SCALE,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: true, // تشغيل الـ logging لمساعدة في التشخيص
      width: PDF_CONFIG.CANVAS_WIDTH,
      height: containerDiv.scrollHeight,
      windowWidth: PDF_CONFIG.CANVAS_WIDTH,
      windowHeight: containerDiv.scrollHeight,
      onclone: (clonedDoc) => {
        console.log('🎨 جاري تطبيق الأنماط المخصصة...');
        
        // إضافة أنماط مخصصة للتأكد من التطبيق الصحيح
        const style = clonedDoc.createElement('style');
        style.textContent = CANVAS_CLONE_STYLES;
        clonedDoc.head.appendChild(style);
        console.log('✅ تم تطبيق الأنماط المخصصة');
      }
    });

    console.log('📊 أبعاد Canvas المُنشأ:', {
      width: canvas.width,
      height: canvas.height
    });

    if (!canvas || canvas.width === 0 || canvas.height === 0) {
      throw new Error('فشل في تصوير المحتوى - Canvas فارغ');
    }

    console.log('✅ تم تصوير المحتوى بنجاح');
    return canvas;
  } catch (error) {
    console.error('❌ خطأ في تصوير المحتوى:', error);
    throw error;
  }
};